import { CollabCanvas } from "./CollabCanvas"

interface ScreenAnnotationProps {
  className?: string
}

// A transparent collaborative drawing layer for annotating ON TOP of a shared
// screen. Same stroke engine as the whiteboard but on its own surface, so
// annotations don't mix with the whiteboard's strokes. Meant to be absolutely
// positioned over a <ScreenShareView>.
export function ScreenAnnotation({ className }: ScreenAnnotationProps) {
  return <CollabCanvas surface="annotation" transparent className={className} />
}
